module.exports = "/packs/images/svg/ireland/facilities/racquet_sports~3d1afa08d922d9f51f5f91a54fb0188a.svg";